﻿window.cObjetErreurMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Erreur"; }
    this.mGetNewLib = function () { return "Nouvelle erreur"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }

    this.mGetIcone = function () { return $("<i class='fas fa-bomb' style='color:red'/>"); }

    this.itemTemplate = function (contentElement, option) {
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:60px;max-width:60px;vertical-align:top;font-size:250%;' class='dx-theme-accent-as-text-color'></td>").appendTo($Tr)
        if (objet.data.stacktrace.startsWith("http")) {$Td.text("JS")}
        else { $Td.text("VB") }
        var $Td = $("<td style='width:200px;max-width:200px;overflow:hidden;text-overflow:ellipsis;vertical-align:top;'>" + objet.data.nom_base + "<br/>" + objet.data.adresse_email + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:100%;vertical-align:top;'><span style='font-size:120%;font-weight:bold;'>" + objet.data.message + "</span><br/></td>").appendTo($Tr)
        var $S = $("<div style='font-size:80%;font-style:italic;white-space:normal;background:linear-gradient(" + theme.color + ", rgba(191, 191, 191, 0.05));-webkit-background-clip: text;-webkit-text-fill-color: transparent;" + ((typeof option.maxheightitem != 'undefined') ? "max-height:" + (option.maxheightitem) + "px;" : "") + "'></div>").appendTo(contentElement)

        var st = objet.data.stacktrace.remplacerTout('C:\\Users\\Sylvain\\Documents\\Mascaron\\solution\\v.1.0.0.0\\', '')
        if (st.startsWith("http")) {
            for (var i = 0; i < st.split(" at ").length; i++) {
                $("<div>" + st.remplacerTout("<", "	&lt;").remplacerTout(">", "&gt;").split(" at ")[i] + "</b></div>").appendTo($S);
            }
        }
        else {
            for (var i = 1; i < st.split(" dans ").length; i++) {
                $("<div>" + st.remplacerTout("<", "	&lt;").remplacerTout(">", "&gt;").split(" dans ")[i].split(" ")[0] + ' <b>' + st.split(" dans ")[i].split(" ")[1] + "</b></div>").appendTo($S);
            }
        }
    }


    this.shading = true;

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.css("font-size", "80%")
        var $Table = $("<table style='font-size:140%;font-weight:bold;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='white-space:nowrap;'>" + objet.data.nom_base + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:100%'>" + objet.data.adresse_email + "</td>").appendTo($Tr)
        var $Td = $("<td style='white-space:nowrap;'>" + objet.data.dcr.toFrenchDateTime() + "</td>").appendTo($Tr)
        if (objet.data.message_interne.length > 0) {
            $("<div style='font-size:120%;font-weight:bold;'>" + objet.data.message_interne + "</div>").appendTo(contentElement)
        }
        if (objet.data.message.length > 0) {
            $("<div style='font-size:120%;font-weight:bold;'>" + objet.data.message + "</div>").appendTo(contentElement)
            var st = objet.data.stacktrace.remplacerTout('C:\\Users\\Sylvain\\Documents\\Mascaron\\solution\\v.1.0.0.0\\', '')
            if (st.startsWith("http")) {
                for (var i = 0; i < st.split(" at ").length; i++) {
                    $("<div>" + st.remplacerTout("<", "	&lt;").remplacerTout(">", "&gt;").split(" at ")[i] + "</b></div>").appendTo(contentElement);
                }
            } else {
                for (var i = 1; i < st.split(" dans ").length; i++) {
                    $("<div style='font-size:120%'>" + st.remplacerTout("<", "	&lt;").remplacerTout(">", "&gt;").split(" dans ")[i].split(" ")[0] + ' <b>' + st.split(" dans ")[i].split(" ")[1] + "</b></div>").appendTo(contentElement);
                }
            }
        }
        if (objet.data.message_inner.length > 0) {
            $("<div style='font-size:150%;font-weight:bold;padding-top:15px;'>INNER EXCEPTION</div>").appendTo(contentElement)
            $("<div style='font-size:100%;font-weight:bold;'>" + objet.data.message_inner + "</div>").appendTo(contentElement)
            $("<div style='font-size:100%;font-style:italic;'>" + objet.data.stacktrace_inner + "</div>").appendTo(contentElement)
        }
        if (objet.data.stacktrace_js.length > 0) {
            $("<div style='font-size:150%;font-weight:bold;padding-top:15px;'>STACKTRACE JS</div>").appendTo(contentElement)
            var st = objet.data.stacktrace_js
            for (var i = 0; i < st.split(" at ").length; i++) {
                $("<div>" + st.remplacerTout("<", "	&lt;").remplacerTout(">", "&gt;").split(" at ")[i] + "</b></div>").appendTo(contentElement);
            }
            //$("<div style='font-size:100%;font-style:italic;'>" + objet.data.stacktrace_js + "</div>").appendTo(contentElement)
        }
        if (objet.data.sql.length > 0) {
            $("<div style='font-size:150%;font-weight:bold;padding-top:15px;'>SQL</div>").appendTo(contentElement)
            $("<div style='font-size:100%;font-style:italic;'>" + objet.data.sql + "</div>").appendTo(contentElement)
        }
        if (objet.data.para_json.length > 0) {
            $("<div style='font-size:150%;font-weight:bold;padding-top:15px;'>PARA JSON</div>").appendTo(contentElement)
            $("<div style='font-size:100%;font-style:italic;'>" + objet.data.para_json.remplacerTout(String.fromCharCode(10),"<br/>") + "</div>").appendTo(contentElement)
        }
    }
    this.contentTemplateCmdPopup = function (pop, contentElement, optionPopup) {

    }

    return this;
}

//function mSaveParaJsonUtilisateur() {
//    //dataToBeSent = JSON.clone(Me.objet.bddRef.utiCourantParaJson))
//    mMigreDateToNet(Me.objet.bddRef.utiCourantParaJson)
//    if (parametre.isLocalhost && JSON.stringify(Me.objet.bddRef.utiCourantParaJson).contains("''''''''")) {
//        alert("Erreur, le json uti est pas bon")
//        alert(mGetStackTrace());
//        debugger;
//    }
//    Me.objet.bddRef.mAjaxCall({ command: "saveoption.bddCtrl.utiCourantParaJson", para_json: JSON.stringify(Me.objet.bddRef.utiCourantParaJson) });
//    mMigreFormatDateFromJson(Me.objet.bddRef.utiCourantParaJson);
//}